export default function ({ redirect, localePath }) {
	if (process.env.MOCK_INTERVIEWS_ENABLED !== 'true') {
		return redirect(localePath({ name: 'index' }));
	}
}
